import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {tap} from "rxjs/operators";
import {CartQuantityNotifier} from "../domain/cart-quantity-notifier";
import {CartLine} from "../domain/dtos/cart-line";
import {CartLineRepository} from "./cart-line-repository.service";
import {TrackRemoveFromCartUseCase} from "@app/core/tracking/application/track-remove-from-cart.use-case";
import {Product} from "@app/core/product/domain/dtos/product";

/**
 *
 */
@Injectable({
    providedIn: "root",
})
export class RemoveProductUseCase {
    constructor(
        private cartLineRepository: CartLineRepository,
        private cartController: CartQuantityNotifier,
        private trackRemoveFromCartUseCase: TrackRemoveFromCartUseCase,
    ) { }

    execute(product: Product): Observable<CartLine | null> {
        this.trackRemoveFromCartUseCase.execute({
            value: product.price ?? 0,
            items: [{
                itemId: product.code,
                itemName: product.name,
            }]
        })
        return this.cartLineRepository.removeProduct(product.code).pipe(
            tap(() => this.cartController.notifyCartQuantityChanged())
        );
    }
}
